<template>
  <div
    class="career-hero-wrapper flex flex-col justify-center lg:bg-light-purple"
    data-test-id="component-career-hero"
  >
    <div class="container">
      <div class="flex flex-wrap  -mx-tiny">
        <div
          class="block w-full lg:w-1/2 px-standart py-large order-2 lg:order-1"
        >
          <h1 class="h1">
            {{ title }}
          </h1>
          <p class="h4">
            {{ body }}
          </p>
        </div>
        <div
          class="img-wrapper block lg:relative w-full lg:w-1/2 px-standart order-1 lg:order-2 lg:align-baseline"
        >
          <img
            class="img lg:absolute"
            :src="img"
            alt="Hero image"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    img: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="postcss" scoped>
@screen lg {
  .career-hero-wrapper {
     margin-top: var(--navbar-height);
     height: 33.70vh;
     min-height: 350px;
     max-height: 20.22rem;
  }

  .img {
    max-width: calc(50vw - 4rem);
    max-height: 25rem;
  }
}
</style>
